import React from 'react';
import { FaLinkedinIn, FaGithub, FaFacebook,FaTelegram } from 'react-icons/fa';
import {IoLogoWhatsapp} from 'react-icons/io'
const Footer = () => {
  return (
    <footer  className="bg-yellow-300 py-6">
      <div  className="container mx-auto px-4 md:px-9">
        <div className="flex items-center justify-between">
          <div>
            <ul className="flex space-x-4 text-xl">
              <li>
                <a href="https://www.linkedin.com/in/bala-chandran-145056228" className="text-gray-600 hover:text-black">
                  <FaLinkedinIn />
                </a>
              </li>
              <li>
                <a href="https://github.com/balachandrans195" className="text-gray-600 hover:text-black">
                  <FaGithub />
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-600 hover:text-black">
                  <FaFacebook />
                </a>
              </li>
              <li>
                <a href="https://wa.me/918072671628" className="text-gray-600 hover:text-black">
                  <IoLogoWhatsapp />
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-600 hover:text-black">
                  <FaTelegram />
                </a>
              </li>
            </ul>
          </div>
          <div>
            <p className="text-center text-gray-600 text-lg">
              &copy; {new Date().getFullYear()} Bala Chandran S . All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
export default Footer;
